/**
 * @author: lza
 * @date: 2023-02-22
 * @Description: 常量
 */
export default {
  // 考试类型
  EXAM_TYPE: {
    EXAM: 0,
    TEST: 1,
    HOMEWORK: 2
  },
  // 学科类型
  SUBJECT_TYPE: {
    BASIC_COURSES: '1',
    PROFESSIONAL_COURSES: '2'
  },
  // 用户类型
  USER_TYPE: {
    SCHOOL: 'school', //学校管理员
    DEAN: 'dean'
  }
}



// WEBPACK FOOTER //
// ./src/common/consts.js